import clientAuth from "../clientAuth";

export default {
  index: () => clientAuth.get("accessory/index"),
  
  store: (userData) => clientAuth.post('accessory/store', { json: userData }),
  

  show:(id)=>clientAuth.get('accessory/show/'+id),

  update:(id,userData)=>clientAuth.post('accessory/update/'+id,{json:userData}),

  destroy:(id)=>clientAuth.delete(`accessory/destroy/${id}`),
};